export default {
    lookup: {
        title: "Lookup",
        search_label: "Search",
        search_placeholder: "",
        column_name: "Name",
        column_createdon: "CreatedOn",
        button_ok: "OK",
        button_removeValue: "Clear Value"
    }
}


//////////////////
// WEBPACK FOOTER
// ./packages/locale/lang/en.js
// module id = 646
// module chunks = 99